const ChevronThinLarge = () => (
    <svg
        width="27"
        height="66"
        viewBox="0 0 27 66"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <line
            y1="-1.5"
            x2="40.173"
            y2="-1.5"
            transform="matrix(-0.597418 -0.80193 0.597419 -0.80193 26 63)"
            stroke="white"
            stroke-width="3"
        />
        <line
            y1="-1.5"
            x2="40.173"
            y2="-1.5"
            transform="matrix(-0.597418 -0.80193 0.597419 -0.80193 26 63)"
            stroke="white"
            stroke-width="3"
        />
        <line
            y1="-1.5"
            x2="38.3875"
            y2="-1.5"
            transform="matrix(-0.597419 0.80193 -0.597418 -0.80193 24.9336 0)"
            stroke="white"
            stroke-width="3"
        />
    </svg>
);

export default ChevronThinLarge;
